// extracted by mini-css-extract-plugin
export default {"accessibilityThemeCta":"oxdKQW","breakline":"Ip_zJs"};